import React from "react";
import {Card, Container} from "@mui/material";
import styles from "../assets/css/embeddedVideo.module.scss";

const EmbeddedVideo = (props) => {

    return <div className={styles.container}>
        <div></div>
        <div></div>
        <div>
            <Container maxWidth={"lg"} component={"div"}>
                <Card elevation={3}>
                    <video autoPlay loop controls={true}>
                        <source src={props.video} type="video/mp4"/>
                        <source src={props.video} type="video/ogg"/>
                    </video>
                </Card>
            </Container>
        </div>
    </div>;
};

export default EmbeddedVideo;